
(function(){
  if(window.__wsmLangReady){ return; }
  window.__wsmLangReady = true;
  function apply(l){
    document.documentElement.lang = (l==='en') ? 'en' : 'ja';
    document.querySelectorAll('.lang-ja').forEach(function(n){ n.hidden = (l==='en'); });
    document.querySelectorAll('.lang-en').forEach(function(n){ n.hidden = (l!=='en'); });
    document.querySelectorAll('.lang-toggle button').forEach(function(b){
      b.setAttribute('aria-pressed', String(b.dataset.lang===l));
    });
    try{ localStorage.setItem('worusam-lang', l); }catch(e){}
  }
  var saved=null;
  try{ saved = localStorage.getItem('worusam-lang'); }catch(e){}
  if(!saved){ saved = (navigator.language||'ja').toLowerCase().indexOf('ja')===0 ? 'ja' : 'en'; }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.lang-toggle button');
    if(b){ apply(b.dataset.lang); }
  });
  apply(saved);
  window.__applyLang = apply;
})();
